import React, { forwardRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { ButtonsWrapper, StyledForm } from "./styled";

import { getRequiredField } from "helpers/formValidations";
import { APARTMENTS_CONFIG, APARTMENTS_PHRASE } from "./config";

import RegularButton from "components/CustomButtons/Button";
import AutocompleteControlled from "components/AutocompleteControlled/AutocompleteControlled";
import { fetchEditApartment, removeAssignedMeter } from "redux/actions/buildings/apartments/apartmentsActions";

const ApartmentsSchema = Yup.object({
  [APARTMENTS_CONFIG.meter.key]: Yup.object().required(
    getRequiredField(APARTMENTS_CONFIG.meter.label)
  )
});

export const AssignMeterForm = forwardRef(props => {
  const dispatch = useDispatch();
  const { handleClose } = props;
  const { isMeterModal, editApartment, meterList } = useSelector(
    state => state.apartments
  );


  const { reset, handleSubmit, setValue, control } = useForm({
    resolver: yupResolver(ApartmentsSchema)
  });

  const handleCloseForm = () => {
    handleClose();
    reset();
  };

  const metersMemo = useMemo(() => {
    const memo = [...meterList];
    if (editApartment?.meter)
      memo.push({
        id: editApartment.meter.id,
        value: editApartment.meter.id,
        label: editApartment.meter.number
      });
    return memo;
  }, [meterList, editApartment]);

  const onSubmit = React.useCallback(
    formData => {
      // You can use the validated data to make your API request here
      const body = {
        idMeter: formData[APARTMENTS_CONFIG.meter.key]?.id
      };

      dispatch(fetchEditApartment(body, editApartment.id));
      if (formData[APARTMENTS_CONFIG.meter.key])
        dispatch(removeAssignedMeter(body.idMeter));
      handleCloseForm();
    },
    [isMeterModal, editApartment]
  );

  useEffect(() => {
    if (editApartment) {
      setValue(
        APARTMENTS_CONFIG.meter.key,
        metersMemo.find(_ => _.id == editApartment.meter?.id)
      );
    }
  }, [metersMemo]);

  return (
    <>
      <StyledForm component="form" fullWidth onSubmit={handleSubmit(onSubmit)}>
        <AutocompleteControlled
          name={APARTMENTS_CONFIG.meter.key}
          label={APARTMENTS_CONFIG.meter.label}
          options={metersMemo}
          control={control}
        />
        <ButtonsWrapper>
          <RegularButton
            variant="contained"
            color="danger"
            onClick={handleCloseForm}
          >
            {APARTMENTS_PHRASE.meterModal.actions.cancel}
          </RegularButton>
          <RegularButton
            variant="contained"
            type="submit"
            color="info"
          >
            {APARTMENTS_PHRASE.meterModal.actions.assign}
          </RegularButton>
        </ButtonsWrapper>
      </StyledForm>
    </>
  );
});
